import script from "./ClaimPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ClaimPanel.vue?vue&type=script&setup=true&lang=js"

import "./ClaimPanel.vue?vue&type=style&index=0&id=b3a3369a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3a3369a"]])

export default __exports__